import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import {
  IOrderSalesApprovalRequestService,
  CHANNEL_SALES_APPROVAL_SERVICE,
} from "../IOrderSalesApprovalRequestService";
import { OrderSalesApprovalRequestPromiseService } from "./OrderSalesApprovalRequestPromiseService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { BaseReplicaActionService } from "./BaseReplicaActionService";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OrderSalesApprovalRequestReplicaService extends BaseReplicaActionService {
  protected broker: ClientMessageBroker;
  modelNotificationFailureEventSubject: Subject<any> = new Subject<any>();
  clientRefreshPort: MessagePort = null;

  constructor(protected factory: ClientMessageBrokerFactory) {
    super();

    this.broker = this.factory.createMessageBroker(CHANNEL_SALES_APPROVAL_SERVICE, true, true);
    this.initModelUpdateService(this.broker, this.clientRefreshPort);
  }

  public requestApproval(
    ids: Array<string>,
    comment: string,
    action: CubiqTS.SalesApprovalAction,
  ): Promise<string> {
    let request = new UiArguments("requestApproval");

    request.args = [
      new FnArg(ids, PRIMITIVE),
      new FnArg(comment, PRIMITIVE),
      new FnArg(action, PRIMITIVE),
    ];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  getModelNotificationFailureEventSubject(): Subject<CubiqTS.ConcreteEncodable> {
    return this.modelNotificationFailureEventSubject;
  }
}
